const SAFE_PROTOCOLS = new Set(['http:', 'https:']);

/**
 * Returns true when `href` uses a safe protocol (http/https).
 * Rejects javascript:, data:, and other dangerous schemes.
 */
export function isSafeUrl(href: string): boolean {
  try {
    const url = new URL(href, window.location.origin);
    return SAFE_PROTOCOLS.has(url.protocol);
  } catch {
    return false;
  }
}

/**
 * Checks whether a URL points to the current origin (in-platform link).
 * Returns the relative path if internal, or null if external.
 * Rejects dangerous protocols (javascript:, data:, etc.) even if they
 * somehow resolve to the same origin.
 */
export function isInternalLink(href: string): { relativePath: string } | null {
  try {
    const url = new URL(href, window.location.origin);
    if (!SAFE_PROTOCOLS.has(url.protocol)) return null;
    if (url.origin === window.location.origin) {
      return { relativePath: url.pathname + url.search + url.hash };
    }
  } catch {
    // Invalid URL
  }
  return null;
}
